/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

export default class InvokeFlowActionMutation extends Relay.Mutation {

    static propTypes = {
        args: PropTypes.object.isRequired,
        flow: PropTypes.object.isRequired,
        flowInvocation: PropTypes.object,
        flowStepDef: PropTypes.object.isRequired,
    };

    static fragments = {
        channel: () => Relay.QL`
              fragment on Flow {
                    organisation_id,
                    id,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {invokeFlowAction}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on InvokeFlowActionPayload {
                success,
                message,
                downloadContent,
                downloadContentType,
                downloadFileName,
                flowInvocation {
                    id,
                    realId,
                    flow_id,
                    organisation_id,
                },
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            flow_id: this.props.flow.id,
            flowStepDef_id: this.props.flowStepDef.realId,
            flowInvocation_id: this.props.flowInvocation ? this.props.flowInvocation.id : null,

            organisation_id: this.props.flow.organisation_id,
            args: JSON.stringify(this.props.args),
        };
    }
}
